import { flatObjectAll } from '../../script.js'

// 新添加的所有翻译必须前面加字母   n   

const language = {
  assets: {},
  components: {
    amap: {

    },
    basics: {
      PointList: {
        cbpl01: {
          zh: "播放范围",
          en: "Range",
          vi: "Phạm vi phát",
          ru: "Диапазон воспроизведения",
          tr: "Oynatma aralığı",
          ja: "再生範囲"
        },
        cbpl02: {
          zh: "播放类容",
          en: "Content",
          vi: "Nội dung phát",
          ru: "Содержимое воспроизведения",
          tr: "Oynatma içeriği",
          ja: "再生コンテンツ"
        }
      }
    },
    device: {

    },
    explorer: {
      index: {
        nei01: {
          zh: "空间不足",
          en: "Insufficient Space",
          vi: "Không đủ dung lượng",
          ru: "Недостаточно места",
          tr: "Yetersiz Alan",
          ja: "空き容量が不足しています"
        }
      },
      MediaItem: {
        nemi01: {
          zh: "待审核",
          en: "Pending Review",
          vi: "Chờ duyệt",
          ru: "Ожидает проверки",
          tr: "İnceleme Bekleniyor",
          ja: "審査待ち"
        },
        nemi02: {
          zh: "拒绝",
          en: "Rejected",
          vi: "Từ chối",
          ru: "Отклонено",
          tr: "Reddedildi",
          ja: "拒否"
        },
        nemi03: {
          zh: "已通过审核",
          en: "Approved",
          vi: "Đã được duyệt",
          ru: "Одобрено",
          tr: "Onaylandı",
          ja: "承認済み"
        },
        nemi04: {
          zh: "已在节目中使用",
          en: "Already Used in Program",
          vi: "Đã được sử dụng trong chương trình",
          ru: "Уже используется в программе",
          tr: "Programda Zaten Kullanılıyor",
          ja: "すでに番組で使用されています"
        }
      }
    },
    home: {
      index: {
        nhi01: {
          zh: "播放时间点",
          en: "Play time",
          vi: "Chơi thời gian",
          ru: "Точка времени проигрывания",
          tr: "Oynatma süresi",
          ja: "再生時点"
        },
        nhi02: {
          zh: "播放设备",
          en: "Play device",
          vi: "Chơi thiết bị",
          ru: "Проигрыватель.",
          tr: "Oynatma cihazı",
          ja: "再生装置"
        },
        nhi03: {
          zh: "其它",
          en: "other",
          vi: "Khác",
          ru: "Прочее",
          tr: "Diğer",
          ja: "その他"
        },
        nhi04: {
          zh: "名称",
          en: "name",
          vi: "Tên",
          ru: "Имя",
          tr: "ad",
          ja: "の名前をあげる",
        },
        nhi05: {
          zh: "数量",
          en: "quantity",
          vi: "lượng",
          ru: "Количество",
          tr: "miktar",
          ja: "数量",
        },
        nhi06: {
          zh: "单价",
          en: "unit price",
          vi: "giá",
          ru: "Стоимость единицы",
          tr: "BİRİM FİYAT",
          ja: "単価",
        },
        nhi07: {
          zh: "总价",
          en: "Total price",
          vi: "giá",
          ru: "Общая стоимость",
          tr: "Fiyat",
          ja: "合計価格",
        },
      }
    },
    log: {
      LoginLog: {
        lll01: {
          zh: "其他",
          en: "other",
          vi: "Khác",
          ru: "Прочее",
          tr: "Diğer",
          ja: "その他",
        },
        lll02: {
          zh: "警告",
          en: "warn",
          vi: "Cảnh báo",
          ru: "предупреждение",
          tr: "uyarmak",
          ja: "に警告",
        },
        lll03: {
          zh: "错误",
          en: "error",
          vi: "Lỗi",
          ru: "Ошибка",
          tr: "hata",
          ja: "エラー",
        },
        lll04: {
          zh: "终端登录",
          en: "Terminal login",
          vi: "Đăng nhập Terminal",
          ru: "Регистрация терминала",
          tr: "Terminal girişi",
          ja: "端末ログイン",
        },
        lll05: {
          zh: "终端退出",
          en: "Terminal exit",
          vi: "Terminal Thoát",
          ru: "Выход терминала",
          tr: "Terminalden çıkışlar",
          ja: "ターミナル終了",
        },
        lll06: {
          zh: "操作",
          en: "operate",
          vi: "Hoạt động",
          ru: "Операция",
          tr: "işletmek",
          ja: "操作",
        }
      }
    },
    login: {
      Register: {
        nlR01: {
          zh: "请输入密码",
          en: "Please input a password",
          vi: "Vui lòng nhập mật khẩu",
          ru: "Введите пароль.",
          tr: "Lütfen şifrenizi giriniz",
          ja: "パスワードを入力してください"
        },
        nlR02: {
          zh: "密码12位及以上且包含字母数字特殊字符",
          en: "Password of 12 characters or more and containing special alphanumeric characters",
          vi: "Mật khẩu 12 chữ số trở lên và bao gồm các ký tự chữ và số đặc biệt",
          ru: "Пароль 12 бит и выше и содержит специальные буквенно - цифровые символы",
          tr: "Parola 12 basamak veya daha fazladır ve alfanümerik özel karakterler içerir",
          ja: "パスワード12ビット以上、英数字特殊文字を含む"
        },
        nlR03: {
          zh: "内容过于简单，请输入真实名称",
          en: "The content is too simple, please enter your real name",
          vi: "Nội dung quá đơn giản, vui lòng nhập tên thật",
          ru: "Содержание слишком простое, введите настоящее имя",
          tr: "İçerik çok basit, lütfen gerçek adı girin",
          ja: "内容が単純すぎるので、真実の名前を入力してください"
        },
        nlR04: {
          zh: "输入您的公司名称或项目名称等，如：****公司。",
          en: "Enter your company name or project name, such as * * * company.",
          vi: "Nhập tên công ty hoặc tên dự án của bạn, v.v., chẳng hạn như: **** Công ty.",
          ru: "Введите название вашей компании или название проекта, например: * * * Компания.",
          tr: "Şirketinizin adını veya proje adını girin, örneğin **** şirket. ",
          ja: "****会社などの会社名やプロジェクト名を入力します。"
        },
        nlR05: {
          zh: "放弃修改",
          en: "Discard changes",
          vi: "Hủy bỏ chỉnh sửa",
          ru: "Отменить изменения",
          tr: "Değişiklikleri iptal et",
          ja: "変更を破棄"
        },
        nlR06: {
          zh: "旧密码",
          en: "Old password",
          vi: "Mật khẩu cũ",
          ru: "Старый пароль",
          tr: "Eski şifre",
          ja: "旧パスワード"
        },
        nlR07: {
          zh: "通过系统分析您的密码过于简单存在潜在风险，为了保证安全使用请先进行密码修改。",
          en: "System analysis shows that your password is too simple and poses potential risks. Please change your password for safe use.",
          vi: "Hệ thống phân tích cho thấy mật khẩu của bạn quá đơn giản và có rủi ro tiềm ẩn. Vui lòng đổi mật khẩu để đảm bảo an toàn.",
          ru: "Система обнаружила, что ваш пароль слишком простой и представляет потенциальный риск. Пожалуйста, измените пароль для безопасного использования.",
          tr: "Sistem analizi şifrenizin çok basit olduğunu ve potansiyel risk taşıdığını gösteriyor. Güvenli kullanım için lütfen şifrenizi değiştirin.",
          ja: "システム分析により、パスワードが単純すぎて潜在的なリスクがあることが判明しました。安全に利用するため、パスワードを変更してください。"
        }

      }
    },
    manage: {

    },
    review: {

    },
    schedule: {
      windows: {
        children: {
          TerminalList: {
            nswct01: {
              zh: "播单名称",
              en: "Name of cast order",
              vi: "Đĩa đơn tên",
              ru: "Одно имя для передачи",
              tr: "Çalma listesinin adı",
              ja: "キャスト名"
            },
            nswct02: {
              zh: "请输入播单名称",
              en: "Please enter the cast name",
              vi: "Hãy nhập tên đĩa đơn",
              ru: "Введите, пожалуйста, название канала",
              tr: "Lütfen bir çalma listesi adı girin",
              ja: "キャスト名を入力してください"
            }
          },
          EditPlan: {
            nswce01: {
              zh: "添加垫片",
              en: "Default",
              vi: "Thêm đoạn chèn",
              ru: "Добавить вставку",
              tr: "Dolgu Ekle",
              ja: "フィラーを追加"
            },
            nswce02: {
              zh: "节目未审核，无法使用",
              en: "Program not reviewed, cannot be used",
              vi: "Chương trình chưa được duyệt, không thể sử dụng",
              ru: "Программа не проверена, использование невозможно",
              tr: "Program incelenmedi, kullanılamaz",
              ja: "番組が未審査のため使用できません"
            },
            nswce03: {
              zh: "垫片节目",
              en: "Filler Program",
              vi: "Chương trình chèn",
              ru: "Программа-заполнитель",
              tr: "Dolgu Programı",
              ja: "フィラー番組"
            },
            nswce04: {
              zh: "没有排期时间内，默认播放垫片。",
              en: "No scheduled time, default to play filler",
              vi: "Không có lịch phát, mặc định phát đoạn chèn",
              ru: "Нет запланированного времени, воспроизводится вставка по умолчанию",
              tr: "Planlanmış zaman yok, varsayılan olarak dolgu oynatılır",
              ja: "スケジュール時間がない場合、デフォルトでフィラーを再生"
            },
            nswce05: {
              zh: "用于节目按设定的时间播放,无时间覆盖默认播放垫片",
              en: "Filler cannot be published alone; it must be published together with a scheduled program.",
              vi: "Đoạn chèn không thể phát hành riêng lẻ; cần phát hành cùng với chương trình theo lịch.",
              ru: "Заполнитель нельзя публиковать отдельно; он должен публиковаться вместе с запланированной программой.",
              tr: "Dolgu tek başına yayınlanamaz; zamanlanmış bir programla birlikte yayınlanmalıdır.",
              ja: "フィラーは単独で公開できず、スケジュールされた番組と組み合わせて公開する必要があります。"
            },
            nswce06: {
              zh: "复制",
              en: "Copy",
              vi: "Sao chép",
              ru: "Копировать",
              tr: "Kopyala",
              ja: "コピー"
            },
            nswce07: {
              zh: "删除",
              en: "Del",
              vi: "Xóa",
              ru: "Удалить",
              tr: "Sil",
              ja: "削除"
            },
            nswce08: {
              zh: "上移",
              en: "Up",
              vi: "Di chuyển lên",
              ru: "Переместить вверх",
              tr: "Yukarı Taşı",
              ja: "上へ移動"
            },
            nswce09: {
              zh: "下移",
              en: "Down",
              vi: "Di chuyển xuống",
              ru: "Переместить вниз",
              tr: "Aşağı Taşı",
              ja: "下へ移動"
            },
            nswce10: {
              zh: "用于节目按设定的时间播放，无时间覆盖默认播放垫片",
              en: "Used for scheduled program playback; default spacer plays when no schedule is active",
              vi: "Được sử dụng để phát chương trình theo lịch trình; trình phát mặc định sẽ phát khi không có lịch nào được kích hoạt",
              ru: "Используется для воспроизведения программ по расписанию; проигрывается заполнитель по умолчанию, когда расписание не активно",
              tr: "Programların zamanlanmış olarak oynatılması için kullanılır; zamanlama etkin değilse varsayılan aralık oynatıcı çalışır",
              ja: "設定された時間にプログラムを再生するために使用されます。スケジュールがない場合はデフォルトのスペーサーが再生されます"
            },
            nswce11: {
              zh: "用于多个节目按顺序无限循环播放",
              en: "Used for sequential infinite loop playback of multiple programs",
              vi: "Được sử dụng để phát nhiều chương trình theo thứ tự lặp vô hạn",
              ru: "Используется для последовательного бесконечного воспроизведения нескольких программ",
              tr: "Birden fazla programın sıralı olarak sonsuz döngüde oynatılması için kullanılır",
              ja: "複数のプログラムを順番に無限ループで再生するために使用されます"
            },
            nswce12: {
              zh: "用于节目紧急投放，完成播放回到原先播放轨迹",
              en: "Used for emergency program insertion; resumes original playback path after completion",
              vi: "Dùng để chèn chương trình khẩn cấp; trở lại đường dẫn phát lại ban đầu sau khi hoàn thành",
              ru: "Используется для экстренного вставки программы; возвращается к исходному пути воспроизведения после завершения",
              tr: "Acil program ekleme için kullanılır; tamamlandıktan sonra orijinal oynatma yoluna geri döner",
              ja: "緊急番組挿入に使用；完了後元の再生経路に戻る"
            }
          }
        }
      },
      programManage: {
        spm01: {
          zh: "节目",
          en: "program",
          vi: "Chương trình",
          ru: "Программа",
          tr: "program",
          ja: "プログラム"
        },
        spm02: {
          zh: "复制节目",
          en: "Copy program",
          vi: "Sao chép chương trình",
          ru: "Копирование программ",
          tr: "Gösteriyi çoğaltın",
          ja: "番組をふくせいする"
        },

      }
    },
    system: {
      TemplateManagement: {
        nstm01: {
          zh: "节目模板管理",
          en: "Program template management",
          vi: "Quản lý mẫu chương trình",
          ru: "Управление шаблонами программ",
          tr: "Program şablonu yönetimi",
          ja: "番組テンプレート管理"
        },
        nstm02: {
          zh: "素材库管理",
          en: "Material library management",
          vi: "Quản lý thư viện tài liệu",
          ru: "Управление библиотекой материалов",
          tr: "Malzeme kütüphanesi yönetimi",
          ja: "素材ライブラリ管理"
        },
        nstm03: {
          zh: "字体库管理",
          en: "Font library management",
          vi: "Quản lý thư viện phông chữ",
          ru: "Управление библиотекой шрифтов",
          tr: "Yazı tipi kütüphanesi yönetimi",
          ja: "フォントライブラリ管理"
        },
        nstm04: {
          zh: "网页工具",
          en: "Web tools",
          vi: "Công cụ web",
          ru: "Веб-инструменты",
          tr: "Web araçları",
          ja: "ウェブツール"
        },
        nstm05: {
          zh: "国内",
          en: "Domestic",
          vi: "Nội địa",
          ru: "Внутренний",
          tr: "Yurtiçi",
          ja: "国内"
        },
        nstm06: {
          zh: "国外",
          en: "Overseas",
          vi: "Nước ngoài",
          ru: "Зарубежный",
          tr: "Yurtdışı",
          ja: "海外"
        },
        nstm07: {
          zh: "新增主题",
          en: "Add new theme",
          vi: "Thêm chủ đề mới",
          ru: "Добавить новую тему",
          tr: "Yeni tema ekle",
          ja: "新しいテーマを追加"
        },
        nstm08: {
          zh: "请问是否要永久删除该主题？",
          en: "Do you want to permanently delete this theme?",
          vi: "Bạn có muốn xóa vĩnh viễn chủ đề này không?",
          ru: "Вы хотите навсегда удалить эту тему?",
          tr: "Bu temayı kalıcı olarak silmek istiyor musunuz?",
          ja: "このテーマを永久に削除しますか？"
        },
        nstm09: {
          zh: "删除主题",
          en: "Delete theme",
          vi: "Xóa chủ đề",
          ru: "Удалить тему",
          tr: "Temayı sil",
          ja: "テーマを削除"
        },
        nstm10: {
          zh: "新增主题",
          en: "Add new theme",
          vi: "Thêm chủ đề mới",
          ru: "Добавить новую тему",
          tr: "Yeni tema ekle",
          ja: "新しいテーマを追加"
        },
        nstm11: {
          zh: "请问是否要永久删除该模板？",
          en: "Do you want to permanently delete this template?",
          vi: "Bạn có muốn xóa vĩnh viễn mẫu này không?",
          ru: "Вы хотите навсегда удалить этот шаблон?",
          tr: "Bu şablonu kalıcı olarak silmek istiyor musunuz?",
          ja: "このテンプレートを永久に削除しますか？"
        },
        nstm12: {
          zh: "删除模板",
          en: "Delete template",
          vi: "Xóa mẫu",
          ru: "Удалить шаблон",
          tr: "Şablonu sil",
          ja: "テンプレートを削除"
        },
        nstm13: {
          zh: "网页小工具",
          en: "Web widgets",
          vi: "Tiện ích web",
          ru: "Веб-виджеты",
          tr: "Web widget'ları",
          ja: "ウェブウィジェット"
        },
        nstm14: {
          zh: "网页工具",
          en: "Web tools",
          vi: "Công cụ web",
          ru: "Веб-инструменты",
          tr: "Web araçları",
          ja: "ウェブツール"
        },
        nstm15: {
          zh: "主题名称",
          en: "Theme name",
          vi: "Tên chủ đề",
          ru: "Название темы",
          tr: "Tema adı",
          ja: "テーマ名"
        },
        nstm16: {
          zh: "主题描述",
          en: "Theme description",
          vi: "Mô tả chủ đề",
          ru: "Описание темы",
          tr: "Tema açıklaması",
          ja: "テーマの説明"
        },
        nstm17: {
          zh: "确认",
          en: "Confirm",
          vi: "Xác nhận",
          ru: "Подтвердить",
          tr: "Onayla",
          ja: "確認"
        },
        nstm18: {
          zh: "取消",
          en: "Cancel",
          vi: "Hủy",
          ru: "Отмена",
          tr: "İptal",
          ja: "キャンセル"
        },
        nstm19: {
          zh: "新增",
          en: "Add",
          vi: "Thêm",
          ru: "Добавить",
          tr: "Ekle",
          ja: "追加"
        },
        nstm20: {
          zh: "修改",
          en: "Edit",
          vi: "Chỉnh sửa",
          ru: "Изменить",
          tr: "Düzenle",
          ja: "編集"
        },
        nstm21: {
          zh: "置顶",
          en: "Pin to top",
          vi: "Ghim lên đầu",
          ru: "Закрепить сверху",
          tr: "En üste sabitle",
          ja: "トップに固定"
        },
        nstm22: {
          zh: "修改",
          en: "Edit",
          vi: "Chỉnh sửa",
          ru: "Изменить",
          tr: "Düzenle",
          ja: "編集"
        },
        nstm23: {
          zh: "点击加载更多模板",
          en: "Click to load more templates",
          vi: "Nhấn để tải thêm mẫu",
          ru: "Нажмите, чтобы загрузить больше шаблонов",
          tr: "Daha fazla şablon yüklemek için tıklayın",
          ja: "クリックしてさらにテンプレートを読み込む"
        },
        nstm24: {
          zh: "已加载全部模板",
          en: "All templates loaded",
          vi: "Đã tải tất cả mẫu",
          ru: "Все шаблоны загружены",
          tr: "Tüm şablonlar yüklendi",
          ja: "すべてのテンプレートが読み込まれました"
        },
        nstm25: {
          zh: "查看",
          en: "View",
          vi: "Xem",
          ru: "Просмотр",
          tr: "Görüntüle",
          ja: "表示"
        },
        nstm26: {
          zh: "参数修改",
          en: "Parameter modification",
          vi: "Chỉnh sửa tham số",
          ru: "Изменение параметров",
          tr: "Parametre düzenleme",
          ja: "パラメータ変更"
        },
        nstm27: {
          zh: "参数名称",
          en: "Parameter name",
          vi: "Tên tham số",
          ru: "Имя параметра",
          tr: "Parametre adı",
          ja: "パラメータ名"
        },
        nstm28: {
          zh: "删除素材",
          en: "Delete material",
          vi: "Xóa tài liệu",
          ru: "Удалить материал",
          tr: "Malzemeyi sil",
          ja: "素材を削除"
        },
        nstm29: {
          zh: "确定要删除素材？",
          en: "Are you sure you want to delete the material?",
          vi: "Bạn có chắc chắn muốn xóa tài liệu này không?",
          ru: "Вы уверены, что хотите удалить материал?",
          tr: "Malzemeyi silmek istediğinizden emin misiniz?",
          ja: "素材を削除してもよろしいですか？"
        },
        nstm30: {
          zh: "添加字体",
          en: "Add font",
          vi: "Thêm phông chữ",
          ru: "Добавить шрифт",
          tr: "Yazı tipi ekle",
          ja: "フォントを追加"
        },
        nstm31: {
          zh: "所属区域",
          en: "Region",
          vi: "Khu vực",
          ru: "Регион",
          tr: "Bölge",
          ja: "所属地域"
        },
        nstm32: {
          zh: "字体文件",
          en: "Font file",
          vi: "Tệp phông chữ",
          ru: "Файл шрифта",
          tr: "Yazı tipi dosyası",
          ja: "フォントファイル"
        },
        nstm33: {
          zh: "选择文件",
          en: "Select file",
          vi: "Chọn tệp",
          ru: "Выбрать файл",
          tr: "Dosya seç",
          ja: "ファイルを選択"
        },
        nstm34: {
          zh: "请上传正确的字体格式文件",
          en: "Please upload a correct font format file",
          vi: "Vui lòng tải lên tệp phông chữ đúng định dạng",
          ru: "Пожалуйста, загрузите файл шрифта правильного формата",
          tr: "Lütfen doğru yazı tipi formatında bir dosya yükleyin",
          ja: "正しいフォント形式のファイルをアップロードしてください"
        },
        nstm35: {
          zh: "请输入名称",
          en: "Please enter a name",
          vi: "Vui lòng nhập tên",
          ru: "Пожалуйста, введите имя",
          tr: "Lütfen bir ad girin",
          ja: "名前を入力してください"
        },
        nstm36: {
          zh: "工具分类",
          en: "Tool category",
          vi: "Phân loại công cụ",
          ru: "Категория инструмента",
          tr: "Araç kategorisi",
          ja: "ツールカテゴリ"
        },
        nstm37: {
          zh: "可以设定自定义分类或下拉选择",
          en: "You can set a custom category or select from the dropdown",
          vi: "Bạn có thể đặt phân loại tùy chỉnh hoặc chọn từ danh sách",
          ru: "Можно задать пользовательскую категорию или выбрать из списка",
          tr: "Özel kategori belirleyebilir veya açılır listeden seçebilirsiniz",
          ja: "カスタムカテゴリを設定するか、ドロップダウンから選択できます"
        },
        nstm38: {
          zh: "工具名称",
          en: "Tool name",
          vi: "Tên công cụ",
          ru: "Название инструмента",
          tr: "Araç adı",
          ja: "ツール名"
        },
        nstm39: {
          zh: "工具描述",
          en: "Tool description",
          vi: "Mô tả công cụ",
          ru: "Описание инструмента",
          tr: "Araç açıklaması",
          ja: "ツールの説明"
        },
        nstm40: {
          zh: "工具截图",
          en: "Tool screenshot",
          vi: "Ảnh chụp công cụ",
          ru: "Скриншот инструмента",
          tr: "Araç ekran görüntüsü",
          ja: "ツールのスクリーンショット"
        },
        nstm41: {
          zh: "添加截图",
          en: "Add screenshot",
          vi: "Thêm ảnh chụp",
          ru: "Добавить скриншот",
          tr: "Ekran görüntüsü ekle",
          ja: "スクリーンショットを追加"
        },
        nstm42: {
          zh: "选取html文件",
          en: "Select HTML file",
          vi: "Chọn tệp HTML",
          ru: "Выбрать HTML-файл",
          tr: "HTML dosyasını seç",
          ja: "HTMLファイルを選択"
        },
        nstm43: {
          zh: "只能上传html文件,且不超过5M",
          en: "Only HTML files up to 5MB can be uploaded",
          vi: "Chỉ có thể tải lên tệp HTML, dung lượng không vượt quá 5MB",
          ru: "Можно загружать только HTML-файлы размером до 5 МБ",
          tr: "Yalnızca 5 MB'a kadar olan HTML dosyaları yüklenebilir",
          ja: "アップロードできるのはHTMLファイルのみで、5MB以下です"
        },
        nstm44: {
          zh: "文件不能为空",
          en: "File cannot be empty",
          vi: "Tệp không được để trống",
          ru: "Файл не может быть пустым",
          tr: "Dosya boş olamaz",
          ja: "ファイルは空にできません"
        },
        nstm45: {
          zh: "请输入工具名称",
          en: "Please enter the tool name",
          vi: "Vui lòng nhập tên công cụ",
          ru: "Пожалуйста, введите название инструмента",
          tr: "Lütfen araç adını girin",
          ja: "ツール名を入力してください"
        },
        nstm46: {
          zh: "工具添加成功!",
          en: "Tool added successfully!",
          vi: "Thêm công cụ thành công!",
          ru: "Инструмент успешно добавлен!",
          tr: "Araç başarıyla eklendi!",
          ja: "ツールが正常に追加されました！"
        },
        nstm47: {
          zh: "请选择或添加分类",
          en: "Please select or add a category",
          vi: "Vui lòng chọn hoặc thêm phân loại",
          ru: "Пожалуйста, выберите или добавьте категорию",
          tr: "Lütfen bir kategori seçin veya ekleyin",
          ja: "カテゴリを選択または追加してください"
        },
        nstm48: {
          zh: "模板",
          en: "Template",
          vi: "Mẫu",
          ru: "Шаблон",
          tr: "Şablon",
          ja: "テンプレート"
        },
        nstm49: {
          zh: "模板描述",
          en: "Template description",
          vi: "Mô tả mẫu",
          ru: "Описание шаблона",
          tr: "Şablon açıklaması",
          ja: "テンプレートの説明"
        },
        nstm50: {
          zh: "请选择屏幕类型",
          en: "Please select screen type",
          vi: "Vui lòng chọn loại màn hình",
          ru: "Пожалуйста, выберите тип экрана",
          tr: "Lütfen ekran türünü seçin",
          ja: "画面タイプを選択してください"
        },
        nstm51: {
          zh: "上传文件",
          en: "Upload file",
          vi: "Tải tệp lên",
          ru: "Загрузить файл",
          tr: "Dosya yükle",
          ja: "ファイルをアップロード"
        },
        nstm52: {
          zh: "上传模板文件",
          en: "Upload template file",
          vi: "Tải tệp mẫu lên",
          ru: "Загрузить файл шаблона",
          tr: "Şablon dosyası yükle",
          ja: "テンプレートファイルをアップロード"
        },
        nstm53: {
          zh: "请上传缩略图",
          en: "Please upload a thumbnail",
          vi: "Vui lòng tải lên hình thu nhỏ",
          ru: "Пожалуйста, загрузите миниатюру",
          tr: "Lütfen küçük resim yükleyin",
          ja: "サムネイルをアップロードしてください"
        },
        nstm54: {
          zh: "请上传正确的模板文件",
          en: "Please upload the correct template file",
          vi: "Vui lòng tải lên tệp mẫu đúng",
          ru: "Пожалуйста, загрузите правильный файл шаблона",
          tr: "Lütfen doğru şablon dosyasını yükleyin",
          ja: "正しいテンプレートファイルをアップロードしてください"
        },
        nstm55: {
          zh: "请上传模板文件",
          en: "Please upload a template file",
          vi: "Vui lòng tải lên tệp mẫu",
          ru: "Пожалуйста, загрузите файл шаблона",
          tr: "Lütfen bir şablon dosyası yükleyin",
          ja: "テンプレートファイルをアップロードしてください"
        },
        nstm56: {
          zh: "横屏",
          en: "Landscape",
          vi: "Ngang",
          ru: "Альбомная ориентация",
          tr: "Yatay",
          ja: "横向き"
        },
        nstm57: {
          zh: "竖屏",
          en: "Portrait",
          vi: "Dọc",
          ru: "Портретная ориентация",
          tr: "Dikey",
          ja: "縦向き"
        },
        nstm58: {
          zh: "该模板已存在",
          en: "This template already exists",
          vi: "Mẫu này đã tồn tại",
          ru: "Этот шаблон уже существует",
          tr: "Bu şablon zaten mevcut",
          ja: "このテンプレートはすでに存在します"
        },
        nstm59: {
          zh: "返回",
          en: "Back",
          vi: "Quay lại",
          ru: "Назад",
          tr: "Geri",
          ja: "戻る"
        },
        nstm60: {
          zh: "添加点位",
          en: "Add point",
          vi: "Thêm điểm",
          ru: "Добавить точку",
          tr: "Nokta ekle",
          ja: "ポイントを追加"
        },
        nstm61: {
          zh: "获取失败",
          en: "Failed to retrieve",
          vi: "Lấy dữ liệu thất bại",
          ru: "Не удалось получить",
          tr: "Alınamadı",
          ja: "取得に失敗しました"
        },
        nstm62: {
          zh: "播放内容",
          en: "Playback content",
          vi: "Nội dung phát",
          ru: "Содержимое воспроизведения",
          tr: "Oynatma içeriği",
          ja: "再生コンテンツ"
        },
        nstm63: {
          zh: "选择节目",
          en: "Select program",
          vi: "Chọn chương trình",
          ru: "Выбрать программу",
          tr: "Program seç",
          ja: "番組を選択"
        },
        nstm64: {
          zh: "添加范围",
          en: "Add range",
          vi: "Thêm phạm vi",
          ru: "Добавить диапазон",
          tr: "Aralık ekle",
          ja: "範囲を追加"
        },
        nstm65: {
          zh: "获取地址失败",
          en: "Failed to get address",
          vi: "Lấy địa chỉ thất bại",
          ru: "Не удалось получить адрес",
          tr: "Adres alınamadı",
          ja: "アドレスの取得に失敗しました"
        },
        nstm66: {
          zh: "点击了标记点：",
          en: "Clicked marker point:",
          vi: "Đã nhấp vào điểm đánh dấu:",
          ru: "Щелкнули по маркеру:",
          tr: "İşaret noktasına tıklandı:",
          ja: "マーカーをクリックしました："
        },
        nstm67: {
          zh: "名称不能为空!",
          en: "Name cannot be empty!",
          vi: "Tên không được để trống!",
          ru: "Имя не может быть пустым!",
          tr: "Ad boş olamaz!",
          ja: "名前は空にできません！"
        },
        nstm68: {
          zh: "播放范围和播放内容不能为空!",
          en: "Playback range and content cannot be empty!",
          vi: "Phạm vi và nội dung phát không được để trống!",
          ru: "Диапазон и содержимое воспроизведения не могут быть пустыми!",
          tr: "Oynatma aralığı ve içeriği boş olamaz!",
          ja: "再生範囲と再生内容は空にできません！"
        },
        nstm69: {
          zh: "请输入主题名称",
          en: "Please enter the theme name",
          vi: "Vui lòng nhập tên chủ đề",
          ru: "Пожалуйста, введите название темы",
          tr: "Lütfen tema adını girin",
          ja: "テーマ名を入力してください"
        },
        nstm70: {
          zh: "请输入参数名称",
          en: "Please enter the parameter name",
          vi: "Vui lòng nhập tên tham số",
          ru: "Пожалуйста, введите имя параметра",
          tr: "Lütfen parametre adını girin",
          ja: "パラメータ名を入力してください"
        },
        nstm71: {
          zh: "点击加载更多字体",
          en: "Click to load more fonts",
          vi: "Nhấn để tải thêm phông chữ",
          ru: "Нажмите, чтобы загрузить больше шрифтов",
          tr: "Daha fazla yazı tipi yüklemek için tıklayın",
          ja: "クリックしてさらにフォントを読み込む"
        },
        nstm72: {
          zh: "已加载全部字体",
          en: "All fonts loaded",
          vi: "Đã tải tất cả phông chữ",
          ru: "Все шрифты загружены",
          tr: "Tüm yazı tipleri yüklendi",
          ja: "すべてのフォントが読み込まれました"
        }

      },
      UserManage: {
        nsu01: {
          zh: "账号数量",
          en: "Number of accounts",
          vi: "Số tài khoản",
          ru: "Количество счетов",
          tr: "Hesap sayısı",
          ja: "アカウント数"
        },
        nsu02: {
          zh: "管理员",
          en: "administrators",
          vi: "Trang chủ",
          ru: "Администратор",
          tr: "Yönetici",
          ja: "管理者"
        },
        nsu03: {
          zh: "操作员",
          en: "operator",
          vi: "Nhà điều hành",
          ru: "Оператор",
          tr: "Operatör",
          ja: "オペレータ"
        },
        nsu04: {
          zh: "审核员",
          en: "auditor",
          vi: "Kiểm toán viên",
          ru: "Ревизоры",
          tr: "Denetçi",
          ja: "監査人"
        },
        nsu05: {
          zh: "用户等级",
          en: "User level",
          vi: "Cấp độ người dùng",
          ru: "Уровень пользователя",
          tr: "Kullanıcı seviyesi",
          ja: "ユーザーレベル"
        },
        nsu06: {
          zh: "请问是否要",
          en: "Do you want to",
          vi: "Bạn có muốn",
          ru: "Вы хотите",
          tr: "İstiyor musunuz",
          ja: "よろしいですか"
        },
        nsu07: {
          zh: "当前或从属设备？",
          en: "the current or subordinate device?",
          vi: "thiết bị hiện tại hoặc thiết bị trực thuộc?",
          ru: "текущее или подчиненное устройство?",
          tr: "mevcut veya bağlı cihazı?",
          ja: "現在のまたは従属デバイスですか？"
        },
        nsu08: {
          zh: "必须12位及以上且包含字母,数字以及特殊字符",
          en: "Must be at least 12 characters and include letters, numbers, and special characters",
          vi: "Phải có ít nhất 12 ký tự và bao gồm chữ cái, số và ký tự đặc biệt",
          ru: "Должен быть не менее 12 символов и содержать буквы, цифры и специальные символы",
          tr: "En az 12 karakter olmalı ve harf, rakam ve özel karakterler içermelidir",
          ja: "12文字以上で、英字・数字・特殊文字を含む必要があります"
        }

      },
      ReviewSetting: {
        nsrs01: {
          zh: "添加审核人员",
          en: "Add auditors",
          vi: "Thêm người đánh giá",
          ru: "Добавить аудиторов",
          tr: "Gözden geçiren ekleme",
          ja: "レビュー担当者の追加"
        }
      },
      OrganizationManage: {
        nsom01: {
          zh: "修改组织结构名称",
          en: "Edit organization structure name",
          vi: "Chỉnh sửa tên cấu trúc tổ chức",
          ru: "Изменить название организационной структуры",
          tr: "Organizasyon yapısı adını düzenle",
          ja: "組織構造名を編集"
        },
        nsom02: {
          zh: "添加组织结构",
          en: "Add Organization Structure",
          vi: "Thêm cơ cấu tổ chức",
          ru: "Добавить структуру организации",
          tr: "Organizasyon Yapısı Ekle",
          ja: "組織構造を追加"
        },
        nsom03: {
          zh: "修改组织结构名称",
          en: "Edit Organization Structure Name",
          vi: "Sửa tên cơ cấu tổ chức",
          ru: "Изменить название структуры организации",
          tr: "Organizasyon Yapısı Adını Düzenle",
          ja: "組織構造名を編集"
        },
        nsom04: {
          zh: "删除组织结构",
          en: "Delete Organization Structure",
          vi: "Xóa cơ cấu tổ chức",
          ru: "Удалить структуру организации",
          tr: "Organizasyon Yapısını Sil",
          ja: "組織構造を削除"
        },
        nsom05: {
          zh: "关闭从属设备",
          en: "Shut Down Subordinate Device",
          vi: "Tắt thiết bị trực thuộc",
          ru: "Выключить подчиненное устройство",
          tr: "Bağlı Cihazı Kapat",
          ja: "従属デバイスをシャットダウン"
        }
      },
      SpaceManage: {
        nssm01: {
          zh: "配置存储",
          en: "Configure Storage",
          vi: "Cấu hình lưu trữ",
          ru: "Настроить хранилище",
          tr: "Depolamayı Yapılandır",
          ja: "ストレージを構成"
        },
        nssm02: {
          zh: "最大使用空间",
          en: "Maximum Used Space",
          vi: "Dung lượng sử dụng tối đa",
          ru: "Максимальное используемое пространство",
          tr: "Maksimum Kullanılan Alan",
          ja: "最大使用容量"
        },
        nssm03: {
          zh: "最大配置空间",
          en: "Maximum Allocated Space",
          vi: "Dung lượng cấu hình tối đa",
          ru: "Максимальное выделенное пространство",
          tr: "Maksimum Tahsis Edilen Alan",
          ja: "最大割り当て容量"
        },
        nssm04: {
          zh: "共享存储",
          en: "Shared Storage",
          vi: "Lưu trữ chia sẻ",
          ru: "Общее хранилище",
          tr: "Paylaşılan Depolama",
          ja: "共有ストレージ"
        },
        nssm05: {
          zh: "自定义",
          en: "Custom",
          vi: "Tùy chỉnh",
          ru: "Пользовательский",
          tr: "Özel",
          ja: "カスタム"
        },
        nssm06: {
          zh: "共享",
          en: "Shared",
          vi: "Chia sẻ",
          ru: "Общий",
          tr: "Paylaşıldı",
          ja: "共有"
        },
        nssm07: {
          zh: "不可以大于上级机构空间",
          en: "Cannot exceed parent organization’s space",
          vi: "Không được vượt quá dung lượng của tổ chức cấp trên",
          ru: "Нельзя превышать пространство родительской организации",
          tr: "Üst kuruluşun alanını aşamaz",
          ja: "上位組織の容量を超えることはできません"
        },
        nssm08: {
          zh: "顶层机构空间不能为0",
          en: "Top-level organization space cannot be 0",
          vi: "Không gian của tổ chức cấp cao không thể bằng 0",
          ru: "Пространство верхнего уровня не может быть равно 0",
          tr: "En üst düzey kuruluşun alanı 0 olamaz",
          ja: "最上位組織の容量は0にできません"
        }
      }
    },
    terminal: {
      children: {
        item: {
          DeviceGps: {

          },
          BatchUpdate: {
            ntcib01: {
              zh: "已选终端",
              en: "Selected",
              vi: "Thiết bị đã chọn",
              ru: "Выбранный терминал",
              tr: "Seçilen terminal",
              ja: "選択された端末"
            }

          }
        },
        HandleOrder: {
          ntch01: {
            zh: "流地址",
            en: "Address of stream",
            vi: "Địa chỉ dòng",
            ru: "Адрес потока",
            tr: "Akış adresi",
            ja: "フローアドレス"
          },
          ntch02: {
            zh: "设备统计导出成功，稍后自动下载!",
            en: "Device statistics exported successfully. It will download automatically shortly!",
            vi: "Xuất thống kê thiết bị thành công, sẽ tự động tải xuống sau!",
            ru: "Статистика устройств успешно экспортирована. Загрузка начнётся автоматически через некоторое время!",
            tr: "Cihaz istatistikleri başarıyla dışa aktarıldı, kısa süre içinde otomatik olarak indirilecek!",
            ja: "デバイス統計のエクスポートが成功しました。まもなく自動的にダウンロードされます！"
          },
          ntch03: {
            zh: "是否要进行播表撤回？",
            en: "Do you want to recall the playlist?",
            vi: "Bạn có muốn thu hồi danh sách phát không?",
            ru: "Вы хотите отозвать плейлист?",
            tr: "Oynatma listesini geri almak istiyor musunuz?",
            ja: "プレイリストを取り消しますか？"
          },
          ntch04: {
            zh: "发布紧急版式",
            en: "Publish emergency layout",
            vi: "Phát hành bố cục khẩn cấp",
            ru: "Опубликовать экстренный макет",
            tr: "Acil yerleşimi yayınla",
            ja: "緊急レイアウトを公開"
          },
          ntch05: {
            zh: "取消紧急版式",
            en: "Cancel emergency layout",
            vi: "Hủy bố cục khẩn cấp",
            ru: "Отменить экстренный макет",
            tr: "Acil yerleşimi iptal et",
            ja: "緊急レイアウトをキャンセル"
          },
          ntch06: {
            zh: "监控云平台连接状态，当连接断开",
            en: "Monitor cloud platform connection status. When the connection is lost",
            vi: "Giám sát trạng thái kết nối nền tảng đám mây. Khi kết nối bị mất",
            ru: "Мониторинг состояния подключения к облачной платформе. Когда соединение разорвано",
            tr: "Bulut platformu bağlantı durumunu izleyin. Bağlantı koptuğunda",
            ja: "クラウドプラットフォームの接続状態を監視し、接続が切れた場合"
          },
          ntch07: {
            zh: "盒子自动尝试重启再登录。",
            en: "The device will automatically attempt to restart and log in again.",
            vi: "Thiết bị sẽ tự động thử khởi động lại và đăng nhập lại.",
            ru: "Устройство автоматически попытается перезапуститься и войти снова.",
            tr: "Cihaz otomatik olarak yeniden başlatmayı ve tekrar giriş yapmayı deneyecek.",
            ja: "デバイスは自動的に再起動して再ログインを試みます。"
          },
          ntch08: {
            zh: "设置日志上传",
            en: "Set log upload",
            vi: "Cài đặt tải lên nhật ký",
            ru: "Настроить загрузку логов",
            tr: "Günlük yüklemeyi ayarla",
            ja: "ログのアップロードを設定"
          },
          ntch09: {
            zh: "字体选择",
            en: "Font selection",
            vi: "Chọn phông chữ",
            ru: "Выбор шрифта",
            tr: "Yazı tipi seçimi",
            ja: "フォント選択"
          },
          ntch10: {
            zh: "播放时静音",
            en: "Mute during playback",
            vi: "Tắt tiếng khi phát",
            ru: "Отключить звук во время воспроизведения",
            tr: "Oynatma sırasında sessize al",
            ja: "再生時にミュート"
          },
          ntch11: {
            zh: "滚动翻页",
            en: "Scroll paging",
            vi: "Cuộn phân trang",
            ru: "Прокрутка с перелистыванием",
            tr: "Kaydırarak sayfa geçişi",
            ja: "スクロールページング"
          },
          ntch12: {
            zh: "滚动",
            en: "Scroll",
            vi: "Cuộn",
            ru: "Прокрутка",
            tr: "Kaydır",
            ja: "スクロール"
          },
          ntch13: {
            zh: "翻页",
            en: "Paging",
            vi: "Phân trang",
            ru: "Перелистывание",
            tr: "Sayfa geçişi",
            ja: "ページ送り"
          },
          ntch14: {
            zh: "滚动速度",
            en: "Scroll speed",
            vi: "Tốc độ cuộn",
            ru: "Скорость прокрутки",
            tr: "Kaydırma hızı",
            ja: "スクロール速度"
          },
          ntch15: {
            zh: "翻页时间",
            en: "Page turning time",
            vi: "Thời gian lật trang",
            ru: "Время перелистывания",
            tr: "Sayfa çevirme süresi",
            ja: "ページ切り替え時間"
          },
          ntch16: {
            zh: "背景图片",
            en: "Background image",
            vi: "Hình nền",
            ru: "Фоновое изображение",
            tr: "Arka plan resmi",
            ja: "背景画像"
          },
          ntch17: {
            zh: "选择图片",
            en: "Select image",
            vi: "Chọn hình ảnh",
            ru: "Выбрать изображение",
            tr: "Resim seç",
            ja: "画像を選択"
          },
          ntch18: {
            zh: "(所选图片必须已经随节目上传到终端)",
            en: "(The selected image must have been uploaded to the terminal with the program)",
            vi: "(Hình ảnh được chọn phải đã được tải lên thiết bị cùng với chương trình)",
            ru: "(Выбранное изображение должно быть загружено на терминал вместе с программой)",
            tr: "(Seçilen resim programla birlikte cihaza yüklenmiş olmalıdır)",
            ja: "（選択した画像は、番組と一緒に端末にアップロードされている必要があります）"
          },
          ntch19: {
            zh: "不处理",
            en: "Do not process",
            vi: "Không xử lý",
            ru: "Не обрабатывать",
            tr: "İşleme",
            ja: "処理しない"
          },
          ntch20: {
            zh: "秒",
            en: "seconds",
            vi: "giây",
            ru: "секунд",
            tr: "saniye",
            ja: "秒"
          },
          ntch21: {
            zh: "开启定点投放",
            en: "Enable targeted advertising",
            vi: "Bật thả điểm",
            ru: "Открыть точку сброса",
            tr: "Hedefli yayınlamayı başlat",
            ja: "定点投入をオンにする"
          },
          ntch22: {
            zh: "关闭定点投放",
            en: "Turn off targeted advertising",
            vi: "Đóng thả điểm",
            ru: "Запуск с фиксированной точкой",
            tr: "Sabit nokta hedeflemesini kapat",
            ja: "定点投入をオフにする"
          },
          ntch23: {
            zh: "群控模式：显示为下发目标值，非设备回读真实状态",
            en: "Group control mode: Shows the target value sent, not the actual device status",
            vi: "Chế độ điều khiển nhóm: Hiển thị giá trị mục tiêu đã gửi, không phải trạng thái thực của thiết bị",
            ru: "Режим группового управления: отображается целевое значение, а не фактический статус устройства",
            tr: "Grup kontrol modu: Gönderilen hedef değeri gösterir, cihazın gerçek durumunu değil",
            ja: "グループ制御モード：送信された目標値を表示し、デバイスの実際の状態ではありません"
          }
        },
        DeviceDetailOpen: {
          ntcd01: {
            zh: "运动轨迹",
            en: "trajectory",
            vi: "Đường đua chuyển động",
            ru: "траектория траэтория движения",
            tr: "Hareket izleri",
            ja: "モーション軌跡"
          }
        }
      },
      Control: {
        ntc01: {
          zh: "上移",
          en: "Move Up",
          vi: "Di chuyển lên",
          ru: "Переместить вверх",
          tr: "Yukarı Taşı",
          ja: "上に移動"
        }

      }
    },
  },
  router: {
    index: {
      ritm: {
        zh: "模板管理",
        en: "Template management",
        vi: "Quản lý mẫu",
        ru: "Управление шаблонами",
        tr: "Şablon yönetimi",
        ja: "テンプレート管理"
      },
      rifp: {
        zh: "定点投放",
        en: "Fixed point delivery",
        vi: "Thả điểm",
        ru: "Сброс с фиксированной точкой",
        tr: "Sabit nokta teslimatı",
        ja: "定点配置"
      },
      spaceManage: {
        zh: "存储管理",
        en: "Storage Management",
        vi: "Quản lý lưu trữ",
        ru: "Управление хранилищем",
        tr: "Depolama Yönetimi",
        ja: "ストレージ管理"
      }

    }
  },
  views: {},
  App: {
  },
  srcStatic: {
    data: {
      contentBtnList: {
        ssdcbl1: {
          zh: "上传日志",
          en: "Upload log",
          vi: "Tải lên một bản ghi",
          ru: "Загрузка.",
          tr: "Günlükleri karşıya yükleme",
          ja: "ログのアップロード"
        },
        ssdcbl2: {
          zh: "添加流媒体",
          en: "Add streaming media",
          vi: "Thêm truyền thông trực tiếp",
          ru: "Добавлять поток",
          tr: "Akış ekle",
          ja: "ストリーミングの追加"
        },
        ssdcbl3: {
          zh: "播表撤回",
          en: "Broadcast table withdrawal",
          vi: "Chơi bảng rút lui",
          ru: "Отбой.",
          tr: "Yayın masası geri çekildi",
          ja: "キャストテーブルの撤回"
        },
        ssdcbl4: {
          zh: "终端导出",
          en: "Terminal export",
          vi: "Xuất khẩu thiết bị đầu cuối",
          ru: "Выход из терминала",
          tr: "Terminal dışa aktarma",
          ja: "ターミナルエクスポート"
        },
        ssdcbl5: {
          zh: "更多控制",
          en: "More Control",
          vi: "Kiểm soát nhiều hơn",
          ru: "Больше контроля.",
          tr: "Daha fazla kontrol",
          ja: "その他の制御"
        }
      }
    }
  }
}


const object = flatObjectAll(language);
const languages = { zh: {}, en: {}, vi: {}, ru: {}, tr: {}, ja: {} };

for (const key in object) {
  if (Object.hasOwnProperty.call(object, key)) {
    const { zh, en, vi, ru, tr, ja } = object[key];
    languages['zh'][key] = zh;
    languages['en'][key] = en;
    languages['vi'][key] = vi;
    languages['ru'][key] = ru;
    languages['tr'][key] = tr;
    languages['ja'][key] = ja;
  }
}

export default languages;